export const QA_NAME_USER_PROFILE_LINK = 'userProfileLink'

export const QA_NAME_USER_SETTINGS_LINK = 'userSettingsLink'
